function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M11.63 5.194a4.768 4.768 0 1 1 9.537 0 4.768 4.768 0 0 1-9.536 0z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M19.26 11.94h-5.723c-3.16 0-5.982 2.578-5.721 5.734.072.878.406 2.793.658 4.169a1.91 1.91 0 0 0 1.878 1.566h12.093a1.91 1.91 0 0 0 1.877-1.566c.253-1.376.587-3.291.659-4.169.26-3.156-2.561-5.734-5.721-5.734z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M22.916 5.245c0 1.398-.45 2.691-1.213 3.744a4.088 4.088 0 1 0 .724-6.195c.315.756.49 1.584.49 2.451z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M27.14 11.894h-3.067c.307.243.597.51.865.8 1.306 1.418 1.94 3.219 1.787 5.07-.058.706-.264 2.04-.614 3.965h3.76c.789 0 1.466-.564 1.609-1.342.216-1.18.502-2.824.564-3.575.224-2.706-2.196-4.918-4.904-4.918z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M11.15 8.947a6.36 6.36 0 0 1-1.214-3.744c0-.867.175-1.695.489-2.45a4.087 4.087 0 1 0 .725 6.195z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M6.08 17.8c-.154-1.85.48-3.651 1.786-5.069.268-.291.558-.557.865-.8H5.664c-2.708 0-5.127 2.211-4.904 4.917.062.752.349 2.395.565 3.575.142.778.82 1.343 1.609 1.343h3.76c-.35-1.925-.557-3.26-.615-3.965z"
})));

var SvgGrpIcon = function SvgGrpIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGrpIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/grp_icon.da42ee6d.svg";
export { ForwardRef as ReactComponent };